export default {
      id: "unistar-usage",
      viewBox: "0 0 100 28",
      url: "assets/" + "sprite.svg#unistar-usage",
      toString: function () {
        return this.url;
      }
    }